/**
 * @file：医生 request
 */
import { ApiConfigs, Response } from '@schemas/service';
import {
  IDoctorInfo,
  IRecommendDoctors,
  CONSULT_GIFT_TYPE,
  IApplyService,
  IResDepartmentBySecondDepartmentId,
  IHealthChannelInfo,
  IShareWorksItem,
  ILiveData
} from '@schemas/doctor';
import serviceFormat from '@utils/services-format';
import { request } from './request';

const api: ApiConfigs = {
  queryDepartment: {
    url: '/health/api/v1/contentRecommend/homeRecommendDoctorTab',
    method: 'GET'
  },
  queryMoreDepartment: {
    url: '/health/api/v1/contentRecommend/moreDoctorDepartments',
    method: 'GET'
  },
  querySelectionDoctors: {
    url: '/health/api/v1/contentRecommend/homeFeaturedDoctors',
    method: 'GET'
  },
  queryDoctorsByDepartmentId: {
    url: '/health/api/v1/consult/queryDoctorPageList',
    method: 'GET'
  },
  queryDoctorListByFilter: {
    url: '/health/api/v1/consult/getDoctorPageList',
    method: 'GET'
  },
  queryRecommendDoctorsByDepartmentId: {
    url: '/health/api/v1/contentRecommend/homeRecommendDoctor',
    method: 'GET'
  },
  queryAllDoctorList: {
    url: '/health/api/v1/consult/queryDoctorProfileList',
    method: 'GET'
  },
  queryDoctorInfo: {
    url: '/health/api/v1/doctor/queryDoctorInfo',
    method: 'GET'
  },

  queryDoctorVideos: {
    url: '/health/api/v1/doctor/queryDoctorVideos',
    method: 'GET'
  },
  queryDoctorOnlineStatus: {
    url: '/health/api/v1/consult/queryDoctorStatusByIds',
    method: 'GET'
  },
  sendAgreeProtocol: {
    url: '/health/api/v1/consult/protocol',
    method: 'POST'
  },
  getRecommendDoctors: {
    // url: 'https://kapi.corp.kuaishou.com/mock/5058/health/api/v1/home/queryRecommendDoctors',
    url: '/health/api/v1/home/queryRecommendDoctors',
    method: 'GET'
  },
  getDoctorIMInfo: {
    url: '/health/api/v1/doctor/queryDoctorIMInfo',
    method: 'GET'
  },
  queryDoctorByHospitalDoctorId: {
    url: '/health/api/v1/doctor/queryDoctorByHospitalDoctorId',
    method: 'GET'
  },
  giveCounsultGift: {
    url: '/health/api/v1/doctorEnd/consult/presentFreeReply', // 赠次数
    method: 'POST'
  },
  getFullTimeDoctorInfo: {
    url: '/health/api/v1/doctor/fullTimeDoctor',
    method: 'GET'
  },
  getListSortRule: {
    url: '/health/api/v1/consult/getDoctorCompositeCondition',
    method: 'GET'
  },
  getFilterRule: {
    url: '/health/api/v1/consult/getDoctorFilterCondition',
    method: 'GET'
  },
  getRecommendDepartmentList: {
    url: '/health/api/v1/contentRecommend/hotDepartment',
    method: 'GET'
  },
  getFilterDepartmentList: {
    url: '/health/api/v1/contentRecommend/getDepartmentList',
    method: 'GET'
  },
  postApplyService: {
    url: '/health/api/v1/doctor/saveReview',
    method: 'POST'
  },
  getApplyServiceForm: {
    url: '/health/api/v1/doctor/getReviewDetail',
    method: 'GET'
  },
  getHealthChannelInfo: {
    url: '/health/api/v1/doctor/healthChannelInfo',
    method: 'GET'
  },
  getLiveData: {
    url: '/health/api/v1/doctor/live',
    method: 'GET'
  },
  getDepartmentBySecondDepartmentId: {
    url: '/health/api/v1/consult/getDepartmentBySecondDepartmentId',
    method: 'GET'
  },
  getShareWorks: {
    method: 'GET',
    url: '/health/api/v1/doctorEnd/consult/queryDoctorVideos'
  },
  // 获取极速咨询弹窗推荐医生
  getRecommendDoctorList: {
    method: 'GET',
    url: '/health/api/v1/contentRecommend/updatingRecommend'
  }
};

const doctors = {
  async getDepartment(isHome = false) {
    const response: Response = await request(
      api.queryDepartment,
      { isHome },
      undefined,
      { hideGlobalLoading: false }
    );
    const { result = [] } = response;
    return result;
  },

  async getMoreDepartment() {
    const response: Response = await request(api.queryMoreDepartment);
    const { result = [] } = response;
    return result;
  },

  async getSelectionDoctors(departmentId: number) {
    const response: Response = await request(api.querySelectionDoctors, {
      departmentId
    });
    const { result = [] } = response;
    return result;
  },

  async getDoctorsList({
    isHome = false,
    pageNum = 1,
    pageSize = 10,
    ...rest
  }: {
    isHome?: boolean;
    pageNum: number;
    pageSize: number;
    departmentId?: number;
    comprehensive?: number;
    doctorTitleList?: number;
    firstDepartmentId?: number;
    priceRangeList?: number;
    secondDepartmentId?: number;
    serviceTypeList?: number;
  }) {
    const listApi = isHome
      ? api.queryRecommendDoctorsByDepartmentId
      : api.queryDoctorListByFilter;

    const queryData = { ...rest };
    queryData &&
      Object.keys(queryData).forEach((key) => {
        if (queryData[key] === undefined || queryData[key] === '') {
          delete queryData[key];
        } else if (Array.isArray(queryData[key])) {
          if (!queryData[key].length) {
            delete queryData[key];
          } else {
            queryData[key] = queryData[key].join();
          }
        }
      });
    try {
      const response: Response = await request(
        listApi,
        {
          pageNum,
          pageSize,
          ...queryData
        },
        undefined,
        { hideGlobalLoading: isHome ? true : pageNum !== 1 }
      );
      const { result } = response;
      if (result) {
        const formatList = result.list.map((item) =>
          serviceFormat.addServiceTypeMapForDoctor(item)
        );
        result.list = formatList;
        return result;
      }
      return {};
    } catch (err) {
      return Promise.reject(err);
    }
  },

  async getAllDoctorList(departmentId: number) {
    try {
      const response: Response<IDoctorInfo[]> = await request(
        api.queryAllDoctorList,
        {
          departmentId
        }
      );
      const { result = [] } = response;
      return result?.map((item) =>
        serviceFormat.addServiceTypeMapForDoctor(item)
      );
    } catch (err) {
      return Promise.reject(err);
    }
  },

  async getDoctorInfo(doctorId: string, options?: any) {
    const response: Response = await request(
      api.queryDoctorInfo,
      {
        doctorId
      },
      undefined,
      {
        hideGlobalLoading: false,
        hideToast: options?.hideToast
      }
    );
    const { result = {} } = response;
    return serviceFormat.addServiceTypeMapForDoctor(result);
  },

  async getDoctorVideos({ doctorId, fromTime, limit }) {
    const response: Response = await request(api.queryDoctorVideos, {
      doctorId,
      fromTime,
      limit
    });
    const { result } = response;
    return result;
  },

  async getDoctorIsOnline(doctorIds) {
    const ids = doctorIds.join(',');
    const response: Response = await request(api.queryDoctorOnlineStatus, {
      doctorIds: ids
    });
    const { result = [] } = response;
    const res = result.map((item) => {
      // status: 0 - 未知, 1 - 在线, 2 - 离线
      if (item.status !== 1) {
        return {
          ...item,
          isOnline: false
        };
      }
      return {
        ...item,
        isOnline: true
      };
    });
    return res;
  },

  async postAgreeProtocol() {
    try {
      const response: Response = await request(
        api.sendAgreeProtocol,
        undefined,
        undefined,
        { hideGlobalLoading: false }
      );
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async getRecommendDoctors() {
    const response: Response<IRecommendDoctors> = await request(
      api.getRecommendDoctors
    );
    const data = {
      famousDoctors: [],
      popularDoctors: []
    };
    const { result = data } = response;
    return result;
  },

  async getDoctorIMInfo(doctorId) {
    const response = await request(api.getDoctorIMInfo, {
      doctorId
    });
    const { result = {} } = response;
    return result;
  },

  async queryDoctorByHospitalDoctorId({ hospitalDoctorId, hospitalIndexId }) {
    const response: Response = await request(
      api.queryDoctorByHospitalDoctorId,
      {
        hospitalDoctorId,
        hospitalIndexId
      }
    );
    const { result = {} } = response;
    return result as IDoctorInfo;
  },

  async giveCounsultGift({
    num,
    orderId
  }: {
    num: CONSULT_GIFT_TYPE;
    orderId: number;
  }) {
    try {
      const response: Response = await request(
        api.giveCounsultGift,
        {
          num,
          orderId
        },
        undefined,
        {
          needResponse: true
        }
      );
      const { code, message } = response;
      return { code, message };
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async getFullTimeDoctorInfo() {
    try {
      const response: Response<IDoctorInfo> = await request(
        api.getFullTimeDoctorInfo
      );
      const { result } = response;
      if (result) {
        return serviceFormat.addServiceTypeMapForDoctor(result);
      }
      return Promise.reject();
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async getListSortRule() {
    try {
      const response: Response<Array<{
        key: number;
        value: string;
      }>> = await request(api.getListSortRule);
      const { result } = response;
      if (result) {
        return result;
      }
      return [];
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async getFilterRule() {
    try {
      const response: Response<any> = await request(api.getFilterRule);
      const { result } = response;
      if (result) {
        return result;
      }
      return [];
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async getFilterDepartmentList() {
    try {
      const response: Response<any> = await request(
        api.getFilterDepartmentList
      );
      const { result } = response;
      if (result) {
        const allDep = [
          {
            firstDepartmentId: 0,
            firstDepartmentName: '全部科室',
            firstDepartmentIcon: '',
            subList: null
          }
        ];
        const newResult = [...allDep, ...result].map((item) => {
          const allSub: any = [
            {
              secondDepartmentId: item.firstDepartmentId,
              firstDepartmentName: item.firstDepartmentName,
              secondDepartmentName: '全部',
              isAll: true
            }
          ];
          let newSubList = allSub;
          if (Array.isArray(item.subList)) {
            newSubList = [...allSub, ...item.subList];
          }
          return {
            ...item,
            subList: newSubList
          };
        });
        return newResult;
      }
      return [];
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async getRecommendDepartmentList() {
    try {
      const response: Response<any> = await request(
        api.getRecommendDepartmentList
      );
      const { result } = response;
      if (result) {
        return result;
      }
      return [];
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async getRecommendDoctorList() {
    try {
      const response: Response<IDoctorInfo[]> = await request(
        api.getRecommendDoctorList
      );
      const { result } = response;
      if (result) {
        return result;
      }
      return [];
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async postApplyService(params: IApplyService) {
    try {
      const response: Response<any> = await request(
        api.postApplyService,
        {},
        params
      );
      const { result } = response;
      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async getApplyServiceForm() {
    try {
      const response: Response<IApplyService> = await request(
        api.getApplyServiceForm
      );
      const { result } = response;
      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async getDepartmentBySecondDepartmentId(secondDepartmentId) {
    try {
      const response: Response<IResDepartmentBySecondDepartmentId | null> = await request(
        api.getDepartmentBySecondDepartmentId,
        { secondDepartmentId },
        undefined,
        { hideGlobalLoading: false }
      );
      const { result } = response;
      if (result) {
        return result;
      }
      return Promise.reject();
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async getHealthChannelInfo(doctorId: string) {
    try {
      const response: Response<IHealthChannelInfo> = await request(
        api.getHealthChannelInfo,
        {
          doctorId
        }
      );
      const { result } = response;
      return result;
    } catch (err) {
      return Promise.reject(err);
    }
  },
  async getShareWorks(params: { fromTime: number; limit: number }) {
    try {
      const { result } = await request(api.getShareWorks, params);
      if (result) {
        return result as IShareWorksItem[];
      }
      return Promise.reject();
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getLiveData() {
    try {
      const reponse: Response<ILiveData> = await request(
        api.getLiveData,
        undefined,
        undefined,
        {
          hideToast: true
        }
      );
      const { result } = reponse;
      if (result) {
        return {
          ...result,
          dates: result.dates.map((item, index) => ({
            key: index + 1,
            date: item
          }))
        };
      }
      return Promise.reject();
    } catch (error) {
      return Promise.reject(error);
    }
  }
};

export default doctors;
